import { Button } from "components/DesignSystem/Button/Button";
import { Cell, flexRender, Row } from "react-table-8.10.7";
import { IncorporationBaseTemplate } from "store/apis/incorporationFormBuilder";

type MobileIncorporationTemplateRowProps = {
  row: Row<IncorporationBaseTemplate>;
  onClick: (template: IncorporationBaseTemplate) => void;
};

// Column ids set on the column helpers in IncorporationTemplates.
const TEMPLATE_COLUMN_ID = {
  TITLE: "title",
  CREATED_BY: "created_by",
  UPDATED_AT: "updated_at",
  ACTIONS: "actions",
} as const;

const renderCell = (cell?: Cell<IncorporationBaseTemplate, unknown>) =>
  cell ? flexRender(cell.column.columnDef.cell, cell.getContext()) : null;

export const MobileIncorporationTemplateRow = ({
  row,
  onClick,
}: MobileIncorporationTemplateRowProps) => {
  const cellsById = Object.fromEntries(
    row.getVisibleCells().map((cell) => [cell.column.id, cell])
  );

  const handleClick = () => onClick(row.original);

  return (
    <div className="t-flex t-items-start t-gap-3 t-border-0 t-border-b t-border-solid t-border-neutral-0 t-py-3 last:t-border-b-0">
      <Button
        type="button"
        customType="ghost"
        onClick={handleClick}
        className="t-flex-1 t-min-w-0 !t-h-auto !t-px-0 !t-whitespace-normal t-text-left t-text-text-100 [&>div]:t-w-full [&>div]:t-justify-start [&>div>div]:t-w-full [&>div>div]:t-justify-start"
      >
        <div className="t-flex t-w-full t-flex-col t-gap-3">
          <div className="t-flex t-min-w-0 t-text-body-sm">
            {renderCell(cellsById[TEMPLATE_COLUMN_ID.TITLE])}
          </div>

          <div className="t-grid t-grid-cols-2 t-gap-3 t-text-body-sm t-font-normal">
            <div className="t-flex t-min-w-0 t-flex-col t-gap-1">
              <span className="t-text-text-30">Made by</span>
              {renderCell(cellsById[TEMPLATE_COLUMN_ID.CREATED_BY])}
            </div>
            <div className="t-flex t-min-w-0 t-flex-col t-gap-1">
              <span className="t-text-text-30">Last updated on</span>
              {renderCell(cellsById[TEMPLATE_COLUMN_ID.UPDATED_AT])}
            </div>
          </div>
        </div>
      </Button>

      <div className="t-shrink-0">
        {renderCell(cellsById[TEMPLATE_COLUMN_ID.ACTIONS])}
      </div>
    </div>
  );
};
